{
  "tabs": {
    "chat": "Chat",
    "reminders": "Tfakkiriet",
    "calendar": "Kalendarju",
    "settings": "Settings"
  },
  "common": {
    "cancel": "Ikkanċella",
    "save": "Issejvja",
    "confirm": "Ikkonferma",
    "delete": "Ħassar",
    "back": "Lura",
    "close": "Agħlaq",
    "edit": "Editja",
    "search": "Fittex",
    "all": "Kollha",
    "loading": "Tgħabba...",
    "error": "Xi ħaġa marret ħażin",
    "notFound": "Ma nstabx",
    "tryAgain": "Jekk jogħġbok erġa' pprova",
    "retry": "Erġa' pprova",
    "undo": "Irrid",
    "pullToRefresh": "Ċappas biex taġġorna",
    "justNow": "għada biss"
  },
  "auth": {
    "welcome": "Merħba f'FishMemory",
    "tagline": "L-assistent tat-tfakkiriet tiegħek fuq WhatsApp, issa fil-but tiegħek.",
    "subtitle": "L-assistent tat-tfakkiriet tiegħek fuq WhatsApp, issa fil-but tiegħek.",
    "phoneLabel": "In-numru WhatsApp tiegħek",
    "phoneHint": "Nibgħatulek kodiċi ta' verifika permezz ta' WhatsApp",
    "invalidPhone": "Jekk jogħġbok daħħal numru tat-telefon validu",
    "continue": "Kompli",
    "enterPhone": "Daħħal in-numru WhatsApp tiegħek",
    "phonePlaceholder": "Numru tat-telefon",
    "sendCode": "Ibgħat Kodiċi",
    "verifyTitle": "Ivverifika n-numru tiegħek",
    "otpSentTo": "Kodiċi ta' 6 ċifri nbgħat lil {{phone}} permezz ta' WhatsApp",
    "enterFullCode": "Jekk jogħġbok daħħal il-6 ċifri kollha",
    "invalidOtp": "Kodiċi mhux validu. Erġa' pprova.",
    "otpFailed": "Ma rnexxiex tibgħat il-kodiċi. Erġa' pprova.",
    "otpResent": "Kodiċi mibgħut mill-ġdid",
    "resendIn": "Ibgħat mill-ġdid fi {{seconds}}s",
    "resendCode": "Ibgħat kodiċi mill-ġdid",
    "enterOtp": "Daħħal il-kodiċi mibgħut fuq WhatsApp tiegħek",
    "verify": "Ivverifika",
    "resend": "Ibgħat kodiċi mill-ġdid",
    "wrongNumber": "Numru żbaljat?",
    "backToPhone": "Lura għan-numru",
    "editPhone": "Editja n-numru tat-telefon",
    "error": "Żball",
    "setupTitle": "Ejja nħaddmu kollox",
    "setupSubtitle": "Tista' tibdel dan dejjem aktar tard fis-Settings",
    "namePlaceholder": "Isem tiegħek",
    "letsGo": "Itlesta l-issettjar",
    "skipForNow": "Agħti pass għal issa"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Ikteb messaġġ...",
    "inputPlaceholder": "Ikteb messaġġ...",
    "typing": "FishMemory qed jikteb...",
    "online": "Online",
    "connecting": "Qiegħed jgħaqqad...",
    "reconnecting": "Qiegħed jerġa' jgħaqqad...",
    "offline": "Offline",
    "empty": "Ibda konversazzjoni",
    "emptyHint": "Oħloq tfakkiriet, iċċekkja l-iskeda tiegħek, jew staqsi għall-għajnuna.",
    "emptyAction": "Ibgħat tfakkira ta' kampjun",
    "actions": "Azzjonijiet tal-chat",
    "keep": "Żomm messaġġi",
    "clearTitle": "Ħassar chat",
    "clearConfirm": "Ħassar il-messaġġi kollha minn dan l-apparat? Dan ma jistax jiġi rkuprat.",
    "clear": "Ħassar chat",
    "optionSelected": "Magħżul: {{label}}",
    "sendingSelection": "Qiegħed jibgħat...",
    "connectionLost": "Qiegħed jerġa' jgħaqqad..."
  },
  "reminders": {
    "title": "It-Tfakkiriet Tiegħi",
    "active": "Attiv",
    "today": "Illum",
    "thisWeek": "Din il-Ġimgħa",
    "history": "Storja",
    "items": "oġġetti",
    "emptyTitle": "Xejn għad m'hemmx tfakkiriet",
    "emptySubtitle": "Oħloq wieħed mill-chat u jidher hawnhekk.",
    "emptyAction": "Iftaħ chat",
    "filterActive": "Attiv",
    "filterToday": "Illum",
    "filterWeek": "Din il-Ġimgħa",
    "filterHistory": "Storja",
    "emptyState": "Xejn għad m'hemmx tfakkiriet. Ibda chat!",
    "swipeDone": "Għamel",
    "swipeSnooze": "Ħalli ftit",
    "swipeDelete": "Ħassar",
    "search": "Fittex tfakkiriet...",
    "upcoming": "Li ġejjin",
    "completed": "Imla",
    "overdue": "Skadut",
    "tomorrow": "Għada",
    "synced": "Sinkronizzat {{value}}",
    "swipeHint": "Ċappas tfakkira għal aktar azzjonijiet",
    "noResults": "L-ebda tfakkira ma tikkorrispondi fit-tfittxija tiegħek",
    "noResultsHint": "Ippruvax kliem ieħor jew ħassar it-tfittxija",
    "deleteAllFailed": "Ma rnexxiex ħassar it-tfakkiriet kollha"
  },
  "calendar": {
    "title": "Kalendarju",
    "today": "Illum",
    "tomorrow": "Għada",
    "completed": "għamel",
    "noEvents": "Xejn ma ġie skedat",
    "noEventsSubtitle": "Agħżel data biex tara tfakkiriet u avvenimenti tal-kalendarju.",
    "googleEvent": "Google Calendar",
    "legendActive": "Attiv",
    "legendRecurring": "Ripetut",
    "legendDone": "Għamel",
    "legendGoogle": "Google",
    "previousMonth": "Xahar preċedenti",
    "nextMonth": "Xahar li jmiss",
    "previousYear": "Sena preċedenti",
    "nextYear": "Sena li jmiss",
    "goToToday": "Mur illum",
    "all": "Kollha",
    "active": "Attiv",
    "done": "Għamel",
    "paused": "Waqqaf"
  },
  "settings": {
    "title": "Settings",
    "profile": "Profil",
    "name": "Isem li jidher",
    "enterName": "Daħħal ismek",
    "language": "Lingwa",
    "uiLanguage": "Lingwa tal-app",
    "uiLanguageHelp": "Jibdel l-UI tal-app, it-tikketti tal-kalendarju, u d-direzzjoni tal-layout fuq dan l-apparat biss.",
    "serverLanguage": "Lingwa tal-chat",
    "serverLanguageHelp": "Jibdel il-lingwa użata mir-risposti tas-server u messaġġi tat-tfakkiriet għall-kont tiegħek.",
    "timezone": "Żona tal-ħin",
    "currentTimezone": "Żona tal-ħin attwali",
    "timezoneHelp": "Il-ħinijiet kollha tat-tfakkiriet jidhru bl-użu ta' din iż-żona tal-ħin.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Issejvja ż-żona tal-ħin",
    "timezoneSaved": "Żona tal-ħin aġġornata",
    "detect": "Skopri",
    "detectFailed": "Ma setgħetx tiskopri ż-żona tal-ħin",
    "autoDetect": "Skopri awtomatikament mill-GPS",
    "notifications": "Notifikazzjonijiet",
    "notificationsHelp": "It-tfakkiriet ta' segwitu jikkontrollaw twissijiet ripetuti wara li tfakkira tkun ġiet mogħtija. Il-permessi tan-notifikazzjoni fuq livell tal-apparat għadhom immaniġġjati fis-settings tat-telefon tiegħek.",
    "pushEnabled": "Notifikazzjonijiet Push",
    "autoDoneOnFire": "Immarka awtomatikament bħala magħmul meta jitħaddem",
    "autoDoneOnFireDesc": "Meta jkun mitfi, it-tfakkiriet jibqgħu attivi sakemm timmarkahom bħala magħmula.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Konness",
    "googleDisconnected": "Mhux konness",
    "googleConnectedHelp": "Tfakkiriet ġodda jistgħu jiġu sinkronizzati mal-kalendarju tiegħek awtomatikament.",
    "googleDisconnectedHelp": "Ikkonnettja Google Calendar biex iżżomm it-tfakkiriet u l-avvenimenti allinjati.",
    "googleConnectFailed": "Ma rnexxiex tikkonnettja Google Calendar",
    "connected": "Konness",
    "disconnected": "Mhux konness",
    "connect": "Ikkonnettja",
    "disconnect": "Ineħħi l-konnessjoni",
    "autoSync": "Sinkronizzazzjoni awtomatika tat-tfakkiriet ġodda",
    "autosync": "Sinkronizzazzjoni awtomatika tat-tfakkiriet ġodda",
    "subscription": "Abbonament",
    "trialUsed": "Prova: {{used}}/{{total}} użati",
    "trialStatus": "Prova disponibbli",
    "activeStatus": "Abbonament attiv",
    "expiredStatus": "Abbonament skadut",
    "unsubscribedStatus": "Mhux abbonat",
    "about": "Dwar",
    "version": "Verżjoni",
    "logout": "Oħroġ",
    "logoutTitle": "Oħroġ",
    "logoutConfirm": "Int żgur li trid toħroġ?",
    "noName": "L-ebda isem ma ġie stabbilit",
    "serverConnection": "Konnessjoni mas-server",
    "serverUrl": "URL tas-server",
    "serverEdit": "Editja",
    "saveReconnect": "Issejvja u erġa' għaqqad",
    "resetDefault": "Irrisettja għall-default",
    "invalidServerUrlTitle": "URL tas-server mhux validu",
    "invalidServerUrlMessage": "Daħħal URL tas-server validu http jew https, pereżempju https://example.com",
    "uiLanguageChangeFailed": "Ma rnexxiex tibdel il-lingwa tal-app. Jekk jogħġbok erġa' pprova.",
    "serverLanguageChangeFailed": "Ma rnexxiex tibdel il-lingwa tal-chat. Jekk jogħġbok erġa' pprova.",
    "timezoneChangeFailed": "Ma rnexxiex tibdel iż-żona tal-ħin. Jekk jogħġbok erġa' pprova.",
    "autoSyncChangeFailed": "Ma rnexxiex aġġorna s-sinkronizzazzjoni awtomatika. Jekk jogħġbok erġa' pprova.",
    "nameChangeFailed": "Ma rnexxiex aġġorna l-isem li jidher. Jekk jogħġbok erġa' pprova.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Dettalji tat-tfakkira",
    "editTime": "Editja l-ħin",
    "rename": "Isem ġdid",
    "snooze": "Ħalli ftit",
    "snooze15": "Ħalli ftit għal 15-il minuta",
    "pause": "Waqqaf",
    "pauseReminder": "Waqqaf it-tfakkira",
    "resume": "Kompli",
    "resumeReminder": "Kompli t-tfakkira",
    "skip": "Agħti pass li jmiss",
    "skipOccurrence": "Agħti pass din l-okkażjoni",
    "syncGoogle": "Sinkronizza ma' Google",
    "delete": "Ħassar",
    "deleteTitle": "Ħassar it-Tfakkira",
    "deleteConfirm": "Din it-tfakkira se tiġi mħassra għal dejjem.",
    "deleteRecurringTitle": "Ħassar tfakkira ripetuta",
    "deleteRecurringMessage": "Trid tagħti pass din l-okkażjoni jew tħassar is-serje kollha?",
    "deleteThisOccurrence": "Agħti pass din l-okkażjoni",
    "deleteEntireSeries": "Ħassar is-serje kollha",
    "done": "Għamel",
    "markDone": "Immarka bħala magħmul",
    "undo": "Irrestawra",
    "undoPrompt": "Tridha attiva mill-ġdid? Irrestawra issa.",
    "recurring": "Ripetut",
    "nextRun": "Li jmiss",
    "oneTime": "Darba waħda",
    "pending": "Pendenti",
    "sent": "Ibgħat",
    "paused": "Waqqaf",
    "active": "Attiv",
    "snoozed": "Ħalla ftit",
    "localTime": "Uri fil-ħin lokali tiegħek",
    "recurrence": "Ripetizzjoni",
    "created": "Maħluq",
    "tags": "Tags",
    "fireCount": "Numru ta' drabi attivat",
    "actions": "Azzjonijiet",
    "none": "Xejn",
    "snoozeFailed": "Ma rnexxiex ħalli ftit it-tfakkira",
    "pauseFailed": "Ma rnexxiex waqqaf it-tfakkira",
    "resumeFailed": "Ma rnexxiex kompli t-tfakkira",
    "skipFailed": "Ma rnexxiex agħti pass it-tfakkira",
    "doneFailed": "Ma rnexxiex immarka t-tfakkira bħala magħmula",
    "undoFailed": "Ma rnexxiex irrestawra l-istatus tat-tfakkira",
    "deleteFailed": "Ma rnexxiex ħassar it-tfakkira",
    "rescheduleTitle": "Irrischedula?",
    "rescheduleMsg": "Din it-tfakkira hija skaduta. Trid tirrischedulaha?",
    "reschedule15": "Fi 15-il minuta",
    "reschedule60": "Fi siegħa",
    "keepOverdue": "Żomm kif inhu"
  },
  "onboarding": {
    "slide1Title": "Merħba f'FishMemory",
    "slide1Sub": "L-assistent personali tat-tfakkiriet tiegħek — imħaddem minn WhatsApp u mibni għall-but tiegħek.",
    "slide2Title": "Chat biss b'mod naturali",
    "slide2Sub": "Ikteb tfakkiriet kif taħseb: \"Tfakkarni nsejjaħ lil omm għada fil-3pm\" — aħna nħarsu l-bqija.",
    "slide3Title": "Qatt ma titlef xejn",
    "slide3Sub": "Ikkonċentra fuq notifikazzjonijiet fil-ħin, organizza b'tags, u żomm kollox taħt kontroll.",
    "getStarted": "Ibda",
    "next": "Li jmiss",
    "firstReminderTitle": "Oħloq it-tfakkira tiegħek l-ewwel!",
    "firstReminderHint": "Ippruvax tiktib xi ħaġa bħal:",
    "firstReminderExample": "Tfakkarni nixrob ilma għada fil-9am",
    "gotIt": "Fhimt!",
    "notifRationaleTitle": "Żomm il-ħin",
    "notifRationaleBody": "FishMemory jeħtieġ notifikazzjonijiet biex jiftakarlek fil-ħin. Int ser tirċievi twissijiet biss għat-tfakkiriet li toħloq.",
    "notifRationaleAllow": "Ħalli Notifikazzjonijiet",
    "notifRationaleLater": "Forse Aktar Tard",
    "swipeHint": "Ċappas lemin għal azzjonijiet mgħaġġla →",
    "calendarDragHint": "Ċappas biex tespandi ↕"
  }
}
